const Marquee = ({ t }) => {
  const row = [...t.marqueeWords, ...t.marqueeWords, ...t.marqueeWords];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative z-10 overflow-hidden border-y border-white/5 py-6"
    >
      <div className="marquee-track">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0 items-center">
            {row.map((w, i) => (
              <span
                key={`${half}-${i}`}
                className="flex items-center whitespace-nowrap font-serif text-xl font-light italic tracking-[0.25em] text-white/40"
              >
                <span className="px-8">{w}</span>
                <span className="text-amber-500/40">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
